import { Sparkles } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router'
import { cn } from '@/lib/utils'
import { useSubscriptionStatus } from '@/api/subscription'

interface Props {
  darkMode: boolean
  collapsed: boolean
  className?: string
}

/**
 * Essai : tout est ouvert, on le dit, avec le compte à rebours et le chemin
 * vers un plan. Partagée par l'administration et le téléphone ; c'est
 * l'appelant qui la réserve au manager (l'agent ne choisit pas le plan).
 */
export function CarteEssai({ darkMode, collapsed, className }: Props) {
  const { t } = useTranslation()
  const { locale = 'fr' } = useParams<{ locale: string }>()
  const navigate = useNavigate()
  const { data: abonnement } = useSubscriptionStatus()

  if (collapsed || abonnement?.subscription?.status !== 'trialing') return null
  const joursEssai = Math.max(0, abonnement.subscription.days_until_trial_end ?? 0)

  return (
    <button
      type="button"
      onClick={() => navigate(`/${locale}/manager?view=billing&action=change-plan`)}
      className={cn(
        'rounded-xl border p-3 text-left transition-colors',
        darkMode
          ? 'border-indigo-500/30 bg-indigo-500/10 hover:bg-indigo-500/20'
          : 'border-blue-200 bg-blue-50 hover:bg-blue-100',
        className,
      )}
    >
      <div className="flex items-start gap-2.5">
        <Sparkles className={cn('h-4 w-4 mt-0.5 shrink-0', darkMode ? 'text-indigo-300' : 'text-blue-600')} />
        <div className="min-w-0">
          <p className={cn('text-[13px] font-semibold leading-snug', darkMode ? 'text-white' : 'text-slate-900')}>
            {t('manager.trialCard.title', 'Toutes les fonctions sont ouvertes pendant votre essai')}
          </p>
          <p className={cn('text-xs mt-0.5', darkMode ? 'text-slate-400' : 'text-slate-500')}>
            {t('manager.trialCard.days', { count: joursEssai })}
          </p>
          <p className={cn('text-xs font-semibold mt-1.5', darkMode ? 'text-indigo-300' : 'text-blue-600')}>
            {t('manager.trialCard.cta', 'Choisir un plan')} →
          </p>
        </div>
      </div>
    </button>
  )
}
